import React from 'react'
import PropTypes from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'
import Loader from 'Pods/Shared/Loader'

class LoadingStep extends React.Component {
  constructor() {
    super()

    this.state = {
      data: {},
      images: [],
      currentRetry: 0,
      notAddedIds: [],
      embeds: [],
    }

    this.getItemImages = this.getItemImages.bind(this)
    this.checkIfAllImagesPrepared = this.checkIfAllImagesPrepared.bind(this)
    this.getItemTitles = this.getItemTitles.bind(this)
  }

  componentDidMount() {
    if (this.props.isAddingToCollection) {
      return axios.put(`/api/internal/collections/${this.props.collectionId}`, { ids: this.props.itemIds })
        .then((response) => this.onUpdateSuccess(response))
        .catch(() => App.events.publish('app:notification:flash:error', 'Something went wrong, please try again'))
    }
    return axios.post('/api/internal/collections', { item_ids: this.props.itemIds })
      .then((response) => this.onCreateSuccess(response))
      .catch(() => App.events.publish('app:notification:flash:error', 'Something went wrong, please try again'))
  }

  onUpdateSuccess(response) {
    const data = response.data.data
    const images = []
    const notAddedIds = response.data.meta.notAddedIds
    const addedCount = this.props.itemIds.length - notAddedIds.length

    this.setState({ data, notAddedIds })

    if (notAddedIds.length > 0) {
      this.showErrors(notAddedIds)
    }

    if (addedCount > 0) {
      App.events.publish('app:notification:flash:success', `${addedCount} models added to the pack.`)
    }

    this.props.changeStep('details', this.props.itemIds, data, images)
  }

  showErrors(notAddedIds) {
    this.getItemTitles(notAddedIds).map(title => App.events.publish('app:notification:flash:error', `"${title}" is already in this pack.`))
  }

  getItemTitles(notAddedIds) {
    const itemTitles = []

    if (notAddedIds.length === 1) {
      itemTitles.push(this.props.selectedItems.find(item => item.id === String(notAddedIds[0])).attributes.title)

      return itemTitles
    }

    this.props.selectedItems.map(item => {
      if (notAddedIds.includes(item.id)) {
        itemTitles.push(item.attributes.title)
      }
    })

    return itemTitles
  }

  onCreateSuccess(response) {
    const data = response.data.data
    this.setState({ data })
    this.getItemImages(data.id)
  }

  getItemImages(id = this.state.data.id) {
    return axios.get(`/api/internal/collections/${id}`)
      .then((response) => this.onFetchSuccess(response))
      .catch(() => App.events.publish('app:notification:flash:error', 'Something went wrong, please try again'))
  }

  onFetchSuccess(response) {
    this.setState({
      data: response.data.data,
      images: response.data.included ? response.data.included.filter(data => data.type === 'itemImages') : [],
      embeds: response.data.included ? response.data.included.filter(data => data.type === 'itemEmbeds') : [],
    })
    this.checkIfAllImagesPrepared()
  }

  checkIfAllImagesPrepared() {
    const delay = 5000 // 5s
    const maxRetryCount = 24 // 2 minutes
    const originalLength = this.state.data.attributes.relatedImageIds.length
    const expectedLength = originalLength + Math.floor(originalLength / 16) + (originalLength % 16 !== 0 ? 1 : 0)
    const expectedEmbedsLength = this.state.data.attributes.relatedEmbedIds.length

    if ((this.state.images.length !== expectedLength || this.state.embeds.length !== expectedEmbedsLength) && this.state.currentRetry < maxRetryCount) {
      setTimeout(() => {
        this.getItemImages()
        this.setState({ currentRetry: this.state.currentRetry + 1 })
      }, delay)
    } else {
      this.props.changeStep('details', this.props.itemIds, this.state.data, this.state.images, this.state.embeds)
    }
  }

  render() {
    return (
      <div className="overlay-modal--loading-content">
        <button className="btn btn-transparent overlay-modal--close-inner" onClick={this.props.onModalClose}>
          <Icon type={['fal', 'times']} color="grey-dark" />
        </button>

        <div className="content-wrapper">
          <div className="u-text-center">
            <Loader isFullHeight />
            <p className="loading-content__title">We're glueing everything together</p>
            <p className="loading-content__text">This may take a few minutes. Please don't close the window as the progress will be lost.</p>
          </div>
        </div>
      </div>
    )
  }
}

LoadingStep.propTypes = {
  onModalClose: PropTypes.func.isRequired,
  changeStep: PropTypes.func.isRequired,
  itemIds: PropTypes.array.isRequired,
  selectedItems: PropTypes.array.isRequired,
  isAddingToCollection: PropTypes.bool.isRequired,
  collectionId: PropTypes.string.isRequired,
}

export default LoadingStep
